import { Button } from '@/atoms/Button'
import { AuthErrorBanner } from '@/molecules/AuthErrorBanner'
import { useAgencyStatusActions } from '@/modules/agencies/hooks/useAgencyStatusActions'

export function AgencyStatusConfirmDialog() {
  const {
    statusConfirm,
    isPending,
    statusError,
    closeStatusConfirm,
    confirmStatusAction,
  } = useAgencyStatusActions()

  if (!statusConfirm) {
    return null
  }

  const isSuspend = statusConfirm.action === 'suspend'
  const title = isSuspend ? 'Suspend agency' : 'Activate agency'
  const description = isSuspend
    ? `Suspend “${statusConfirm.agencyName}”? The agency will lose platform access until reactivated.`
    : `Activate “${statusConfirm.agencyName}”? The agency will regain platform access.`
  const confirmLabel = isPending
    ? isSuspend
      ? 'Suspending…'
      : 'Activating…'
    : isSuspend
      ? 'Suspend agency'
      : 'Activate agency'

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center px-4">
      <button
        type="button"
        aria-label="Close status confirmation"
        className="absolute inset-0 bg-ink/40"
        disabled={isPending}
        onClick={closeStatusConfirm}
      />
      <div
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="agency-status-confirm-title"
        aria-describedby="agency-status-confirm-description"
        className="relative z-10 w-full max-w-md border-2 border-ink bg-surface p-6"
      >
        <h2
          id="agency-status-confirm-title"
          className="font-display text-2xl font-medium tracking-[-0.02em] text-ink"
        >
          {title}
        </h2>
        <p
          id="agency-status-confirm-description"
          className="mt-2 text-sm text-muted"
        >
          {description}
        </p>

        <div className="mt-4">
          <AuthErrorBanner message={statusError} />
        </div>

        <div className="mt-6 flex flex-wrap gap-3">
          <Button
            type="button"
            disabled={isPending}
            onClick={() => void confirmStatusAction()}
            className={
              isSuspend
                ? 'border-accent bg-accent text-surface hover:bg-accent'
                : undefined
            }
          >
            {confirmLabel}
          </Button>
          <Button
            type="button"
            variant="ghost"
            disabled={isPending}
            onClick={closeStatusConfirm}
          >
            Cancel
          </Button>
        </div>
      </div>
    </div>
  )
}
